import React from "react";
import { Form, Col, Row } from "react-bootstrap";
import {
  FOCUS_ISSUES,
  TREATMENT_APPROACHES,
  INSURANCE_TYPES,
} from "../utility/constants";
import DropdownWithSearch from "components/dropdown-with-search";
import RadioButton from "components/radio-button";
import Checkbox from "components/checkbox/Checkbox";
import getClasses from "utils/getClasses";
import styles from "./styles.module.scss";
import { track } from "utils/amplitude";

const SERVICES_OFFERED = [
  { value: "telehealth", label: "Telehealth services only" },
  {
    value: "telehealth and in person",
    label: "Telehealth and in-person services",
  },
];

const INSURANCE_ACCEPTED = [
  { value: "take insurance", label: "Yes, I take insurance" },
  { value: "no insurance", label: "No, I don't take insurance" },
];

// BE set enum value?
const CLIENTELE_AGE = [
  { value: "Children (6-12)", label: "Children (6-12)" },
  { value: "Teenager (13-17)", label: "Teenager (13-17)" },
  { value: "Young adults (18-24)", label: "Young adults (18-24)" },
  { value: "Adults (25-64)", label: "Adults (25-64)" },
  { value: "Seniors (65+)", label: "Seniors (65+)" },
];

// BE set enum value?
const CLIENTELE_COMMUNITY = [
  { value: "Trans & Non-binary", label: "Trans & Non-binary" },
  { value: "LGBTQIA +", label: "LGBTQIA +" },
  { value: "HIV/AIDS", label: "HIV/AIDS" },
];

const MODALITY = [
  { value: "individuals", label: "Individuals" },
  { value: "couples", label: "Couples" },
  { value: "aids", label: "HIV/AIDS" },
  { value: "families", label: "Families" },
  { value: "groups", label: "Groups" },
];

const PersonalDetails = ({
  fieldChangedCallback,
  registration,
  data,
  amplitudePageName,
}) => {
  const onInputChange = (event) => {
    const inputField = event.currentTarget;
    const { name, value } = inputField;
    let obj = {
      [name]: value,
    };
    fieldChangedCallback(name, value, obj);
  };

  const addInsurance = () => {
    const { insurance_accepted } = data;
    const newData = [...insurance_accepted, ""];
    fieldChangedCallback("insurance_accepted", newData);
  };

  const onCheckboxChange = (event) => {
    const { name, value, checked } = event.target;
    let selected = data[name] || [];
    if (checked) {
      selected.push(value);
    } else {
      selected = selected.filter((selectedVal) => selectedVal !== value);
    }
    fieldChangedCallback(name, selected);
  };

  return (
    <div className={!registration ? styles["intake-form--edit-profile"] : ""}>
      <div className={styles["edit-profile__card"]}>
        <Row>
          <Col className={styles["edit-profile__col"]}>
            <div className={styles["edit-profile__col-div"]}>
              {!registration && (
                <div
                  className={getClasses(
                    styles["intake-form__title"],
                    styles["intake-form__title--edit-profile"],
                  )}
                >
                  Focus Issues
                </div>
              )}
              <div className={"mt-0"}>
                <div
                  className={getClasses("mb-0", styles["intake-form__title"])}
                >
                  {!registration ? "" : "1. "}What is your focus issues?
                </div>
                <p className={getClasses(registration && "ml-3", "rg-16")}>
                  Select up to 10
                </p>
              </div>
              <Form.Group>
                <Form.Label className={styles["intake-form__form-label"]}>
                  Focus Issues <span className="required">*</span>
                </Form.Label>
                <DropdownWithSearch
                  fieldChangedCallback={fieldChangedCallback}
                  fieldName={"focus_issues"}
                  data={data.focus_issues || []}
                  options={FOCUS_ISSUES}
                  placeholder={"Select Focus Issues"}
                  onClick={() =>
                    track(amplitudePageName, "focus-issues-selector", "click")
                  }
                />
              </Form.Group>
            </div>
          </Col>
          <Col className={styles["edit-profile__col"]}>
            <div className={styles["edit-profile__col-div"]}>
              {!registration && (
                <div
                  className={getClasses(
                    styles["intake-form__title"],
                    styles["intake-form__title--edit-profile"],
                  )}
                >
                  Treatment Approach
                </div>
              )}
              <div className={getClasses("mb-0", styles["intake-form__title"])}>
                {!registration ? "" : "2. "}What is your treatment
                approach/plan?
              </div>
              <p className={getClasses(registration && "ml-3", "rg-16")}>
                Select up to 10
              </p>

              <Form.Group>
                <Form.Label className={styles["intake-form__form-label"]}>
                  Types of Treatment Plans <span className="required">*</span>
                </Form.Label>
                <DropdownWithSearch
                  fieldChangedCallback={fieldChangedCallback}
                  fieldName={"treatment_approaches"}
                  data={data.treatment_approaches || []}
                  options={TREATMENT_APPROACHES}
                  placeholder={"Select Types of Treatment Approach/Plans"}
                  onClick={() =>
                    track(
                      amplitudePageName,
                      "treatment-approach-selector",
                      "click",
                    )
                  }
                />
              </Form.Group>
            </div>
          </Col>
        </Row>
      </div>

      {/* {!registration && (
        <hr
          className={getClasses(
            styles["intake-form__hr"],
            styles["intake-form__hr--edit-profile"],
          )}
        />
      )} */}

      <div className={styles["edit-profile__card"]}>
        {registration ? (
          <div
            className={getClasses(
              styles["intake-form__title"],
              styles["intake-form__extra-spacing"],
            )}
          >
            3. Who is your client?
          </div>
        ) : (
          <div
            className={getClasses(
              styles["intake-form__title"],
              styles["intake-form__title--edit-profile"],
            )}
          >
            Client Focus
          </div>
        )}
        <Row>
          <Col className={"pl-0"}>
            <p>
              Client Age group (select up to 3){" "}
              <span className="required">*</span>
            </p>
            <div className={styles["intake-form__checkbox-group"]}>
              {CLIENTELE_AGE.map((option, index) => (
                <Checkbox
                  variant={"rectangle"}
                  id={`clientele_age-${index}`}
                  key={`clientele_age-${index}`}
                  name="clientele_age"
                  label={option.label}
                  value={option.value}
                  checked={(data.clientele_age || []).includes(option.value)}
                  onChange={onCheckboxChange}
                  className={getClasses(
                    styles["intake-form__checkbox"],
                    styles["intake-form__checkbox-spacing"],
                  )}
                  onClick={() =>
                    track(
                      amplitudePageName,
                      "client-focus-age-checkbox",
                      "click",
                    )
                  }
                />
              ))}
            </div>
          </Col>
          <Col>
            <p>
              Community (select up to 3) <span className="required">*</span>
            </p>
            <div className={styles["intake-form__checkbox-group"]}>
              {CLIENTELE_COMMUNITY.map((option, index) => (
                <Checkbox
                  variant={"rectangle"}
                  id={`clientele_community-${index}`}
                  key={`clientele_community-${index}`}
                  name="clientele_community"
                  label={option.label}
                  value={option.value}
                  checked={(data.clientele_community || []).includes(
                    option.value,
                  )}
                  onChange={onCheckboxChange}
                  className={getClasses(
                    styles["intake-form__checkbox"],
                    styles["intake-form__checkbox-spacing"],
                  )}
                  onClick={() =>
                    track(
                      amplitudePageName,
                      "client-focus-community-checkbox",
                      "click",
                    )
                  }
                />
              ))}
            </div>
          </Col>

          <Col className={"pr-0"}>
            <p>
              Modality (select up to 3) <span className="required">*</span>
            </p>
            <div className={styles["intake-form__checkbox-group"]}>
              {MODALITY.map((option, index) => (
                <Checkbox
                  variant={"rectangle"}
                  id={`modality-${index}`}
                  key={`modality-${index}`}
                  name="modality"
                  label={option.label}
                  value={option.value}
                  checked={(data.modality || []).includes(option.value)}
                  onChange={onCheckboxChange}
                  className={getClasses(
                    styles["intake-form__checkbox"],
                    styles["intake-form__checkbox-spacing"],
                  )}
                  onClick={() =>
                    track(
                      amplitudePageName,
                      "client-focus-modality-checkbox",
                      "click",
                    )
                  }
                />
              ))}
            </div>
          </Col>
        </Row>
      </div>

      {/* {!registration && (
        <hr
          className={getClasses(
            styles["intake-form__hr"],
            styles["intake-form__hr--edit-profile"],
          )}
        />
      )} */}

      <div className={styles["edit-profile__card"]}>
        <div className={getClasses(styles["intake-form__title"])}>
          {!registration && (
            <div
              className={getClasses(
                styles["intake-form__title"],
                styles["intake-form__title--edit-profile"],
              )}
            >
              Appointment Type
            </div>
          )}
          {!registration ? "" : "4. "}What is your appointment type?{" "}
          <span className="required">*</span>
        </div>
        {SERVICES_OFFERED.map((radio, index) => {
          return (
            <RadioButton
              key={`services_offered-${index}`}
              id={radio.value}
              className={styles["intake-form__radio"]}
              label={radio.label}
              value={radio.value}
              name="services_offered"
              onChange={onInputChange}
              checked={data.services_offered === radio.value}
              onClick={() =>
                track(
                  amplitudePageName,
                  "appointment-type-radio-button",
                  "click",
                )
              }
            />
          );
        })}
      </div>

      {/* {!registration && (
        <hr
          className={getClasses(
            styles["intake-form__hr"],
            styles["intake-form__hr--edit-profile"],
          )}
        />
      )} */}

      <div className={styles["edit-profile__card"]}>
        <div className={styles["edit-profile__col-div"]}>
          <div className={getClasses(styles["intake-form__title"])}>
            {!registration && (
              <div
                className={getClasses(
                  styles["intake-form__title"],
                  styles["intake-form__title--edit-profile"],
                )}
              >
                Insurance
              </div>
            )}
            {!registration ? "" : "5. "}Do you take insurance?{" "}
            <span className="required">*</span>
          </div>

          <RadioButton
            id={INSURANCE_ACCEPTED[0].value}
            className={styles["intake-form__radio"]}
            label={INSURANCE_ACCEPTED[0].label}
            value={INSURANCE_ACCEPTED[0].value}
            name="insurance_accepted"
            onChange={addInsurance}
            checked={data.insurance_accepted?.length !== 0}
            onClick={() =>
              track(
                amplitudePageName,
                "do-you-take-insurance-radio-button",
                "click",
              )
            }
          />

          {data.insurance_accepted?.length > 0 && (
            <Form.Group>
              <Form.Label className={styles["intake-form__form-label"]}>
                Insurance Type
              </Form.Label>
              <DropdownWithSearch
                fieldChangedCallback={fieldChangedCallback}
                fieldName={"insurance_accepted"}
                data={data.insurance_accepted || []}
                options={INSURANCE_TYPES}
                placeholder={"Select Insurance Type"}
                onClick={() =>
                  track(amplitudePageName, "insurance-type-dropdown", "click")
                }
              />
            </Form.Group>
          )}

          <RadioButton
            id={INSURANCE_ACCEPTED[1].value}
            className={styles["intake-form__radio"]}
            label={INSURANCE_ACCEPTED[1].label}
            value={INSURANCE_ACCEPTED[1].value}
            name="insurance_accepted"
            onChange={() => fieldChangedCallback("insurance_accepted", [])}
            checked={data.insurance_accepted?.length === 0}
            onClick={() =>
              track(
                amplitudePageName,
                "do-you-take-insurance-radio-button",
                "click",
              )
            }
          />
        </div>
      </div>
    </div>
  );
};

export default PersonalDetails;
